import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { customFixed } from '../../../../shared/utility';
import './CountdownTimer.scss';

export const CountdownTimer = ({initialTime = 0}) => {
    const { paymentRequest } = useSelector(({app}) => app);
    const timer = useRef();
    const [leftTime, setLeftTime] = useState(initialTime); // time left in seconds
    
    const getClockTime = () => {
        const minutes = ((leftTime / 1000) / 60);
        const seconds = ((minutes - Math.floor(minutes)) * 60);
        if(initialTime <= 0 || (minutes <= 0)) {
            if(timer.current) {
                clearInterval(timer.current);
            }
            return "00:00";
        }
        return `${customFixed(minutes, 0).replace('.', '').padStart(2, "0")}:${customFixed(seconds, 0).replace('.', '').padStart(2, '0')}`
    } 

    useEffect(() => {
        const _leftTime = new Date(paymentRequest.expirationTime).getTime() - Date.now();
        if(_leftTime > 0 && paymentRequest.status === "pending"){
            setLeftTime((_leftTime));
        }

        timer.current = setInterval(() => {
            setLeftTime(prev => {
                if(prev <= 0) clearInterval(timer.current);
                return prev > 0 ? prev - 1000 : 0;
            })
        }, 1000);

        return () => {
            clearInterval(timer.current);
        }
        //eslint-disable-next-line
    }, []);

    return (
        <div className={`countdown-timer-component`}>
            <div className="countdown-timer-component__inner">
                <p>{getClockTime()}</p>
            </div>
        </div>
    )
}

export default CountdownTimer;